<template>
  <b-modal
    ref="CPCreateUserModal"
    hide-footer
    centered
    title="Create user"
  >
    <b-form
      @submit.prevent="save"
      v-if="dashboards && users"
    >
      <b-form-group label="Dashboard:">
        <b-form-select
          :options="availableDashboards"
          v-model="$v.selectedDashboard.$model"
          :class="{ 'is-invalid': $v.selectedDashboard.$error }"
          :disabled="inProgress"
        >
        </b-form-select>
        <b-form-invalid-feedback
          v-if="!$v.selectedDashboard.required"
          >
          Dashboard is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Role:">
        <b-form-select
          :options="availableRoles"
          v-model="selectedRole"
          :disabled="inProgress"
        >
        </b-form-select>
      </b-form-group>
      <b-form-group label="E-mail:">
        <b-form-input
          v-model="$v.email.$model"
          :class="{ 'is-invalid': $v.email.$error }"
          placeholder="example@domain.com"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.email.required"
          >
          E-mail is required
        </b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.email.email"
          >
          This field should contain a valid E-mail address
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Display Name:">
        <b-form-input
          v-model="$v.displayName.$model"
          :class="{ 'is-invalid': $v.displayName.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.displayName.required"
          >
          Display Name is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Team Name:">
        <b-form-input
          v-model="$v.teamName.$model"
          :class="{ 'is-invalid': $v.teamName.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.teamName.required"
          >
          Team Name is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Website ID:">
        <b-form-input
          v-model="$v.websiteId.$model"
          :class="{ 'is-invalid': $v.websiteId.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.websiteId.required"
          >
          Website ID is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Password:" v-if="!autoPass">
        <b-form-input
          v-model="$v.pass.$model"
          :class="{ 'is-invalid': $v.pass.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.pass.required"
          >
          Password is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          v-model="autoPass"
          :disabled="inProgress"
        >
          Generate password
        </b-form-checkbox>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          v-model="invite"
          :disabled="inProgress"
        >
          Send invitation
        </b-form-checkbox>
      </b-form-group>
      <div>
        <b-button
          variant="primary"
          type="submit"
          :disabled="inProgress"
        >Save</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
import auth from '@/services/auth'
import user from '@/services/user'

export default {
  props: ['users', 'dashboards'],
  data () {
    return {
      email: null,
      autoPass: true,
      pass: null,
      invite: true,
      selectedDashboard: null,
      availableRoles: [
        { value: 'read', text: 'Regular' },
        { value: 'update', text: 'Moderator' }
      ],
      selectedRole: 'read',
      inProgress: false,
      displayName: null,
      teamName: null,
      websiteId: null
    }
  },
  computed: {
    availableDashboards () {
      const items = []

      for (let dId in this.dashboards) {
        const dashboard = this.dashboards[dId]

        items.push({
          value: dId,
          text: dashboard.name,
        })
      }

      return items
    }
  },
  methods: {
    closeModal () {
      if (this.$refs['CPCreateUserModal']) {
        this.$refs['CPCreateUserModal'].hide()
      }
    },
    async save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      const idToken = await auth.getIdToken()
      const vm = this
      const data = {
        email: vm.email,
        idToken,
        invite: vm.invite,
        dashboard: vm.selectedDashboard,
        role: vm.selectedRole,
        displayName: vm.displayName,
        teamName: vm.teamName,
        websiteId: vm.websiteId
      }

      if (this.autoPass) data.pass = this.genPass(6)
      else data.pass = this.pass

      user.create(data)
        .then(() => {
          this.inProgress = false
          this.email = null
          this.selectedRole = 'read'
          this.selectedDashboard = null
          this.pass = null
          this.autoPass = true
          this.invite = true
          this.displayName = null
          this.teamName = null
          this.websiteId = null

          if (this.$refs['CPCreateUserModal']) {
            this.$refs['CPCreateUserModal'].hide()
          }
        })
        .catch((err) => {
          this.inProgress = false
          console.error(err)
        })
    },
    genPass (length) {
      var text = ''
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }

      return text
    }
  },
  created () {
    eventBus.$on('showCPCreateUserModal', () => {
      if (this.$refs['CPCreateUserModal']) {
        this.$refs['CPCreateUserModal'].show()
      }
    })
  },
  validations: {
    selectedDashboard: {
      required
    },
    email: {
      required,
      email
    },
    displayName: {
      required
    },
    teamName: {
      required
    },
    websiteId: {
      required
    },
    pass: {
      required (val) {
        if (this.autoPass) return true
        if (val && val.length) return true
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ControlPanel/modals/CreateUser.vue